import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { OnboardingModal } from "../modals/OnboardingModal";

export const OnboardingCheck: React.FC = () => {
  const { user, profile, loading } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading) return;

    // Check if user is logged in
    if (user && profile) {
      // Check if profile is incomplete (missing full_name)
      const isProfileIncomplete = !profile.full_name;

      // Check if user has already skipped onboarding in this session
      const hasSkipped = sessionStorage.getItem("hasSkippedOnboarding");

      if (isProfileIncomplete && !hasSkipped) {
        setTimeout(() => setOpen(true), 0);
      }
    }
  }, [user, profile, loading]);

  const handleClose = () => {
    setOpen(false);
    // Mark as skipped for this session so it doesn't pop up again immediately
    sessionStorage.setItem("hasSkippedOnboarding", "true");
  };

  return <OnboardingModal open={open} onClose={handleClose} />;
};
